import { AccordionDetails, Box } from '@mui/material';

import styled from 'styled-components';

export const StyledAccordionDetails = styled(AccordionDetails)`
  background-color: #fff;
  color: ${props => props.theme.palette.grey[900]};
`;

export const CheckoutBoxWrapper = styled(Box)`
width: 100%;
padding: ${props => props.theme.spacing(3)};
background-color: #fff;
border: 1px solid #e7e7e7;
border-radius: 14px;
display: flex;
flex-direction: column;

${props => props.theme.breakpoints.down('sm')} {
  padding: ${props => props.theme.spacing(2)};
  box-shadow: none;
  border-radius: 0px;
  border-top: 1px solid ${props => props.theme.palette.grey[300]};
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};
  }
`;
